<template>
    <v-dialog v-model="dialog" max-width="450">
        <template v-slot:activator="{ on }">
            <v-fab-transition>
                <v-btn icon v-on="on" class="px-0" :title="$t('Удаление документа')">
                    <v-icon dense>mdi-delete</v-icon>
                </v-btn>
            </v-fab-transition>
        </template>

        <v-card style="border-radius: 10px">
            <p class="dialog-header"><v-spacer /><v-icon @click="dialog = false" class="mx-1 my-1 white--text pointer">close</v-icon></p>
            <v-card-text>
                <center class="pt-2" style="font-size: 16px !important" v-html="DeleteDocument">{{ DeleteDocument }}</center>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn outlined @click="dialog = false" color="info" class="popup-btn rounded-btn">{{ $t('Отмена') }}</v-btn>

                <v-btn color="info" @click="doDelete()" style="margin-left: 30px !important" class="popup-btn rounded-btn">{{ $t('Удалить') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
import { sprintf } from 'sprintf-js';
import translate from '@/utils/translate.util';

export default {
    computed: {
        ...mapState('documents', ['Pagination', 'ContractRid', 'KSKRid']),
        ...mapState('users', ['userInfo']),
        translatedDocument() {
            return translate(this.documentItem, 'full', this.$i18n.locale);
        },
        DeleteDocument() {
            return `${this.$t('Вы действительно хотите удалить документ')} <br/><br/>

                     ${this.translatedDocument.doc_type_name}  <br/> ${this.translatedDocument.attach_file_name} ?`;
        }
    },
    props: ['documentItem', 'isContract'],
    data() {
        return {
            dialog: false
        };
    },
    methods: {
        ...mapActions('documents', ['postDoc', 'getDocumentList']),
        ...mapActions('users', ['getUserInfo']),
        async doDelete() {
            this.loading = true;
            try {
                await this.getUserInfo();
                let data = {};
                data.record_id = this.documentItem.record_id;
                data.user_rid = this.userInfo.record_id;
                data.to_delete = 1;
                let res = await this.postDoc({ nvcDocumentsData: data });
                if (res && res.successfull) {
                    let color = 'success';
                    let message = this.$t('Документ успешно удален');
                    this.$store.dispatch('base/showMessage', { color, message });
                }
                if (this.isContract) {
                    await this.getDocumentList({
                        ContractRid: this.ContractRid,
                        itemsPerPage: this.Pagination.itemsPerPage,
                        currentItem: this.Pagination.itemsPerPage * (this.Pagination.page - 1)
                    });
                } else {
                    await this.getDocumentList({
                        KSKRid: this.KSKRid,
                        itemsPerPage: this.Pagination.itemsPerPage,
                        currentItem: this.Pagination.itemsPerPage * (this.Pagination.page - 1)
                    });
                }
                this.dialog = false;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style>
.popup-btn {
    display: block;
    margin: auto;
}
</style>
